import { SettingRow } from '@hive/component/setting-components';
import { UserQuotaService } from '@hive/core/modules/cloud';
import { useI18n } from '@hive/i18n';
import { useLiveData, useService } from '@toeverything/infra';
import { useEffect } from 'react';

import * as styles from './style.css';

export const LifetimePlanCard = ({ planName }: { planName: string }) => {
  const t = useI18n();
  const userQuotaService = useService(UserQuotaService);

  useEffect(() => {
    userQuotaService.quota.revalidate();
  }, [userQuotaService]);

  const maxFormatted = useLiveData(userQuotaService.quota.maxFormatted$);
  const usedFormatted = useLiveData(userQuotaService.quota.usedFormatted$);

  return (
    <div className={styles.planCard}>
      <div className={styles.currentPlan}>
        <SettingRow
          spreadCol={false}
          name={
            <div className={styles.currentPlanHeader}>
              <span>Hive Cloud</span>
              <span className={styles.lifetimeBadge}>Lifetime</span>
            </div>
          }
          desc={
            <>
              {t[
                'com.hive.payment.billing-setting.lifetime-plan.description'
              ]?.({ planName }) ??
                `You have a ${planName} subscription. Enjoy lifetime access!`}
              <br />
              <span className={styles.storageInfo}>
                Storage: {usedFormatted ?? '...'} / {maxFormatted ?? '...'}
              </span>
            </>
          }
        />
      </div>
      <p className={styles.planPrice}>
        <span className={styles.lifetimeLabel}>Lifetime</span>
      </p>
    </div>
  );
};
